module.exports = __webpack_public_path__ + "img/charity_box.9cf36c62.svg";